import { useLocation } from "react-router-dom";

export const Usericon = () => {
  return (
    <div>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.525 17.3C7.375 16.6667 8.3 16.1667 9.3 15.8C10.3 15.4333 11.3667 15.25 12.5 15.25C13.6333 15.25 14.7 15.4333 15.7 15.8C16.7 16.1667 17.625 16.6667 18.475 17.3C19.0917 16.6167 19.5833 15.825 19.95 14.925C20.3167 14.025 20.5 13.05 20.5 12C20.5 9.78333 19.721 7.89567 18.163 6.337C16.6043 4.779 14.7167 4 12.5 4C10.2833 4 8.396 4.779 6.838 6.337C5.27933 7.89567 4.5 9.78333 4.5 12C4.5 13.05 4.68333 14.025 5.05 14.925C5.41667 15.825 5.90833 16.6167 6.525 17.3ZM12.5 12.75C11.5833 12.75 10.8127 12.4373 10.188 11.812C9.56267 11.1873 9.25 10.4167 9.25 9.5C9.25 8.58333 9.56267 7.81267 10.188 7.188C10.8127 6.56267 11.5833 6.25 12.5 6.25C13.4167 6.25 14.1873 6.56267 14.812 7.188C15.4373 7.81267 15.75 8.58333 15.75 9.5C15.75 10.4167 15.4373 11.1873 14.812 11.812C14.1873 12.4373 13.4167 12.75 12.5 12.75ZM12.5 21.5C11.1833 21.5 9.946 21.25 8.788 20.75C7.62933 20.25 6.625 19.575 5.775 18.725C4.925 17.875 4.25 16.8707 3.75 15.712C3.25 14.554 3 13.3167 3 12C3 10.6833 3.25 9.44567 3.75 8.287C4.25 7.129 4.925 6.125 5.775 5.275C6.625 4.425 7.62933 3.75 8.788 3.25C9.946 2.75 11.1833 2.5 12.5 2.5C13.8167 2.5 15.0543 2.75 16.213 3.25C17.371 3.75 18.375 4.425 19.225 5.275C20.075 6.125 20.75 7.129 21.25 8.287C21.75 9.44567 22 10.6833 22 12C22 13.3167 21.75 14.554 21.25 15.712C20.75 16.8707 20.075 17.875 19.225 18.725C18.375 19.575 17.371 20.25 16.213 20.75C15.0543 21.25 13.8167 21.5 12.5 21.5ZM12.5 20C13.4 20 14.271 19.854 15.113 19.562C15.9543 19.2707 16.7 18.8667 17.35 18.35C16.7 17.85 15.9623 17.4583 15.137 17.175C14.3123 16.8917 13.4333 16.75 12.5 16.75C11.5667 16.75 10.6877 16.8877 9.863 17.163C9.03767 17.4377 8.3 17.8333 7.65 18.35C8.3 18.8667 9.04567 19.2707 9.887 19.562C10.729 19.854 11.6 20 12.5 20ZM12.5 11.25C13 11.25 13.4167 11.0833 13.75 10.75C14.0833 10.4167 14.25 10 14.25 9.5C14.25 9 14.0833 8.58333 13.75 8.25C13.4167 7.91667 13 7.75 12.5 7.75C12 7.75 11.5833 7.91667 11.25 8.25C10.9167 8.58333 10.75 9 10.75 9.5C10.75 10 10.9167 10.4167 11.25 10.75C11.5833 11.0833 12 11.25 12.5 11.25Z"
          fill="#737780"
        />
      </svg>
    </div>
  );
};
export const ClenderIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8333 1.66669V5.00002M7.16667 1.66669V5.00002M3 8.33335H18M4.66667 3.33335H16.3333C17.2538 3.33335 18 4.07955 18 5.00002V16.6667C18 17.5872 17.2538 18.3334 16.3333 18.3334H4.66667C3.74619 18.3334 3 17.5872 3 16.6667V5.00002C3 4.07955 3.74619 3.33335 4.66667 3.33335Z"
        stroke="#FF4CFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Passwordicon = () => {
  return (
    <div>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 11H7.5C6.39543 11 5.5 11.8954 5.5 13V19C5.5 20.1046 6.39543 21 7.5 21H17.5C18.6046 21 19.5 20.1046 19.5 19V13C19.5 11.8954 18.6046 11 17.5 11Z"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 17C13.0523 17 13.5 16.5523 13.5 16C13.5 15.4477 13.0523 15 12.5 15C11.9477 15 11.5 15.4477 11.5 16C11.5 16.5523 11.9477 17 12.5 17Z"
          stroke="#667085"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 11V7C8.5 5.93913 8.92143 4.92172 9.67157 4.17157C10.4217 3.42143 11.4391 3 12.5 3C13.5609 3 14.5783 3.42143 15.3284 4.17157C16.0786 4.92172 16.5 5.93913 16.5 7V11"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
export const Eyeicon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
        <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
      </svg>
    </div>
  );
};
export const Eye2icon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
      </svg>
    </div>
  );
};
export const Arrowicon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="7"
        viewBox="0 0 10 7"
        fill="none"
      >
        <path
          d="M0.711914 6.01344L3.87425 3.00689C3.89892 2.98343 3.93747 2.98282 3.96287 3.0055L5.78302 4.63009C5.80879 4.6531 5.84802 4.65209 5.87258 4.62779L9.30336 1.2326"
          stroke="#A4B4CB"
          strokeWidth="1.30811"
        />
        <path
          d="M6.5603 1.23254H9.3046V3.97684"
          stroke="#A4B4CB"
          strokeWidth="1.30811"
        />
      </svg>
    </div>
  );
};
export const Rangeicon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <rect
          x="0.107422"
          y="0.119568"
          width="17.0054"
          height="17.0054"
          rx="3.92433"
          fill="#FF4CFF"
        />
        <rect
          x="11.1245"
          y="4.69769"
          width="1.30811"
          height="7.84866"
          rx="0.654055"
          fill="white"
        />
        <rect
          x="7.95642"
          y="6.66003"
          width="1.30811"
          height="5.8865"
          rx="0.654055"
          fill="white"
        />
        <rect
          x="4.78796"
          y="8.62207"
          width="1.30811"
          height="3.92433"
          rx="0.654055"
          fill="white"
        />
      </svg>
    </div>
  );
};
export const Arrowicon2 = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
      >
        <circle cx="6.71912" cy="6.26581" r="6" fill="#FF4CFF" />
        <path
          d="M3.89746 8.44654L5.79699 6.40499C5.8223 6.37779 5.86517 6.37711 5.89133 6.4035L6.95435 7.4761C6.98088 7.50286 7.02446 7.50174 7.04957 7.47365L9.11215 5.1662"
          stroke="white"
          strokeWidth="0.981083"
        />
        <path
          d="M7.44666 5.1662H9.11234V7.04918"
          stroke="white"
          strokeWidth="0.981083"
        />
      </svg>
    </div>
  );
};
export const Arrowicon3 = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="7"
        viewBox="0 0 9 7"
        fill="none"
      >
        <path
          d="M0.624878 6.19643L3.41451 3.19822C3.43982 3.17102 3.48269 3.17034 3.50885 3.19673L5.10243 4.80466C5.12895 4.83142 5.17254 4.8303 5.19765 4.80221L8.22486 1.41559"
          stroke="#0177FD"
          strokeWidth="1.30811"
        />
        <path
          d="M5.79834 1.41559H8.22594V4.15989"
          stroke="#0177FD"
          strokeWidth="1.30811"
        />
      </svg>
    </div>
  );
};
export const Downarrowicon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="4"
        viewBox="0 0 7 4"
        fill="none"
      >
        <path
          d="M6.8519 1.28763C6.85212 1.35091 6.83815 1.41343 6.81103 1.47061C6.78391 1.52779 6.74432 1.57816 6.69517 1.61803L4.15365 3.66395C4.07785 3.72626 3.98278 3.76031 3.88467 3.76031C3.78656 3.76031 3.69148 3.72626 3.61569 3.66395L1.07416 1.54602C0.987661 1.47412 0.933262 1.3708 0.922935 1.25879C0.912608 1.14678 0.947199 1.03526 1.0191 0.948757C1.091 0.862253 1.19432 0.807854 1.30632 0.797527C1.41833 0.7872 1.52985 0.821791 1.61636 0.89369L3.88679 2.78713L6.15722 0.957229C6.21939 0.905431 6.29511 0.872528 6.3754 0.862413C6.45569 0.852298 6.5372 0.865394 6.61028 0.900152C6.68336 0.93491 6.74495 0.989874 6.78777 1.05854C6.83059 1.12721 6.85285 1.20671 6.8519 1.28763Z"
          fill="#040707"
        />
      </svg>
    </>
  );
};
export const Dashboardicon = () => {
  const router = useLocation().pathname;

  return (
    <div>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        className={`group-hover:fill -primary fill-white ${
          router === "/" ? "fill -primary" : ""
        }`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20.4949 8.09817L14.5444 2.88164C13.999 2.39375 13.2928 2.12402 12.561 2.12402C11.8291 2.12402 11.123 2.39375 10.5775 2.88164L4.62708 8.09817C4.31208 8.3799 4.0607 8.7255 3.8897 9.11197C3.7187 9.49843 3.63199 9.9169 3.63535 10.3395V19.0073C3.63535 19.7963 3.94881 20.5531 4.50677 21.111C5.06473 21.669 5.82148 21.9825 6.61055 21.9825H18.5114C19.3005 21.9825 20.0572 21.669 20.6152 21.111C21.1731 20.5531 21.4866 19.7963 21.4866 19.0073V10.3296C21.4885 9.90865 21.4011 9.49209 21.2302 9.10744C21.0592 8.72279 20.8086 8.37879 20.4949 8.09817ZM14.5444 19.999H10.5775V15.0403C10.5775 14.7773 10.682 14.525 10.868 14.3391C11.054 14.1531 11.3062 14.0486 11.5692 14.0486H13.5527C13.8157 14.0486 14.068 14.1531 14.254 14.3391C14.44 14.525 14.5444 14.7773 14.5444 15.0403V19.999ZM19.5031 19.0073C19.5031 19.2703 19.3986 19.5225 19.2126 19.7085C19.0267 19.8945 18.7744 19.999 18.5114 19.999H16.5279V15.0403C16.5279 14.2512 16.2145 13.4945 15.6565 12.9365C15.0985 12.3786 14.3418 12.0651 13.5527 12.0651H11.5692C10.7802 12.0651 10.0234 12.3786 9.46544 12.9365C8.90748 13.4945 8.59403 14.2512 8.59403 15.0403V19.999H6.61055C6.34753 19.999 6.09528 19.8945 5.90929 19.7085C5.72331 19.5225 5.61882 19.2703 5.61882 19.0073V10.3296C5.619 10.1888 5.64916 10.0496 5.7073 9.92136C5.76544 9.79311 5.85022 9.67871 5.95601 9.58577L11.9064 4.37916C12.0874 4.22017 12.3201 4.13248 12.561 4.13248C12.8019 4.13248 13.0345 4.22017 13.2155 4.37916L19.1659 9.58577C19.2717 9.67871 19.3565 9.79311 19.4146 9.92136C19.4728 10.0496 19.5029 10.1888 19.5031 10.3296V19.0073Z" />
      </svg>
    </div>
  );
};
export const Invoicesicon = () => {
  return (
    <div>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        className="group-hover:fill -primary fill-white"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.5687 8.61167H16.5191C16.7822 8.61167 17.0344 8.50718 17.2204 8.3212C17.4064 8.13521 17.5109 7.88296 17.5109 7.61993C17.5109 7.35691 17.4064 7.10466 17.2204 6.91867C17.0344 6.73268 16.7822 6.6282 16.5191 6.6282H10.5687C10.3057 6.6282 10.0535 6.73268 9.86747 6.91867C9.68149 7.10466 9.577 7.35691 9.577 7.61993C9.577 7.88296 9.68149 8.13521 9.86747 8.3212C10.0535 8.50718 10.3057 8.61167 10.5687 8.61167ZM8.58526 12.5786H16.5191C16.7822 12.5786 17.0344 12.4741 17.2204 12.2881C17.4064 12.1022 17.5109 11.8499 17.5109 11.5869C17.5109 11.3239 17.4064 11.0716 17.2204 10.8856C17.0344 10.6996 16.7822 10.5951 16.5191 10.5951H8.58526C8.32224 10.5951 8.06999 10.6996 7.884 10.8856C7.69802 11.0716 7.59353 11.3239 7.59353 11.5869C7.59353 11.8499 7.69802 12.1022 7.884 12.2881C8.06999 12.4741 8.32224 12.5786 8.58526 12.5786ZM8.58526 16.5456H16.5191C16.7822 16.5456 17.0344 16.4411 17.2204 16.2551C17.4064 16.0691 17.5109 15.8168 17.5109 15.5538C17.5109 15.2908 17.4064 15.0385 17.2204 14.8526C17.0344 14.6666 16.7822 14.5621 16.5191 14.5621H8.58526C8.32224 14.5621 8.06999 14.6666 7.884 14.8526C7.69802 15.0385 7.59353 15.2908 7.59353 15.5538C7.59353 15.8168 7.69802 16.0691 7.884 16.2551C8.06999 16.4411 8.32224 16.5456 8.58526 16.5456ZM20.4861 2.66125H4.61832C4.3553 2.66125 4.10305 2.76574 3.91706 2.95173C3.73107 3.13771 3.62659 3.38997 3.62659 3.65299V21.5042C3.62659 21.6884 3.67787 21.8689 3.7747 22.0256C3.87153 22.1823 4.01007 22.3089 4.1748 22.3913C4.33954 22.4736 4.52395 22.5085 4.70739 22.492C4.89082 22.4754 5.06602 22.4081 5.21336 22.2976L7.26626 20.7604L9.30923 22.2976C9.4809 22.4264 9.68969 22.496 9.90427 22.496C10.1189 22.496 10.3276 22.4264 10.4993 22.2976L12.5522 20.7604L14.6051 22.2976C14.7768 22.4264 14.9856 22.496 15.2001 22.496C15.4147 22.496 15.6235 22.4264 15.7952 22.2976L17.8382 20.7604L19.8911 22.2976C20.0391 22.408 20.215 22.4748 20.399 22.4906C20.583 22.5063 20.7677 22.4704 20.9324 22.3869C21.0959 22.3045 21.2335 22.1784 21.3297 22.0226C21.426 21.8668 21.4773 21.6874 21.4778 21.5042V3.65299C21.4778 3.38997 21.3733 3.13771 21.1874 2.95173C21.0014 2.76574 20.7491 2.66125 20.4861 2.66125ZM19.4944 19.5208L18.4332 18.7274C18.2615 18.5986 18.0527 18.529 17.8382 18.529C17.6236 18.529 17.4148 18.5986 17.2431 18.7274L15.2001 20.2646L13.1472 18.7274C12.9756 18.5986 12.7668 18.529 12.5522 18.529C12.3376 18.529 12.1288 18.5986 11.9572 18.7274L9.90427 20.2646L7.8613 18.7274C7.68963 18.5986 7.48084 18.529 7.26626 18.529C7.05167 18.529 6.84288 18.5986 6.67122 18.7274L5.61006 19.5208V4.64473H19.4944V19.5208Z" />
      </svg>
    </div>
  );
};
export const Usericons = () => {
  const router = useLocation().pathname;

  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M12.3 12.4594C12.8336 11.9975 13.2616 11.4263 13.5549 10.7844C13.8482 10.1425 14 9.44509 14 8.73938C14 7.4133 13.4732 6.14153 12.5355 5.20385C11.5979 4.26616 10.3261 3.73938 9 3.73938C7.67392 3.73938 6.40215 4.26616 5.46447 5.20385C4.52678 6.14153 4 7.4133 4 8.73938C3.99999 9.44509 4.1518 10.1425 4.44513 10.7844C4.73845 11.4263 5.16642 11.9975 5.7 12.4594C4.30014 13.0933 3.11247 14.1169 2.27898 15.4079C1.4455 16.6989 1.00147 18.2027 1 19.7394C1 20.0046 1.10536 20.259 1.29289 20.4465C1.48043 20.634 1.73478 20.7394 2 20.7394C2.26522 20.7394 2.51957 20.634 2.70711 20.4465C2.89464 20.259 3 20.0046 3 19.7394C3 18.1481 3.63214 16.622 4.75736 15.4967C5.88258 14.3715 7.4087 13.7394 9 13.7394C10.5913 13.7394 12.1174 14.3715 13.2426 15.4967C14.3679 16.622 15 18.1481 15 19.7394C15 20.0046 15.1054 20.259 15.2929 20.4465C15.4804 20.634 15.7348 20.7394 16 20.7394C16.2652 20.7394 16.5196 20.634 16.7071 20.4465C16.8946 20.259 17 20.0046 17 19.7394C16.9985 18.2027 16.5545 16.6989 15.721 15.4079C14.8875 14.1169 13.6999 13.0933 12.3 12.4594ZM9 11.7394C8.40666 11.7394 7.82664 11.5634 7.33329 11.2338C6.83994 10.9041 6.45542 10.4356 6.22836 9.88743C6.0013 9.33925 5.94189 8.73605 6.05764 8.15411C6.1734 7.57217 6.45912 7.03762 6.87868 6.61806C7.29824 6.1985 7.83279 5.91278 8.41473 5.79702C8.99667 5.68127 9.59987 5.74068 10.1481 5.96774C10.6962 6.1948 11.1648 6.57932 11.4944 7.07267C11.8241 7.56602 12 8.14604 12 8.73938C12 9.53503 11.6839 10.2981 11.1213 10.8607C10.5587 11.4233 9.79565 11.7394 9 11.7394ZM18.74 12.0594C19.38 11.3387 19.798 10.4484 19.9438 9.49572C20.0896 8.543 19.9569 7.56845 19.5618 6.68938C19.1666 5.81031 18.5258 5.06418 17.7165 4.5408C16.9071 4.01743 15.9638 3.73912 15 3.73938C14.7348 3.73938 14.4804 3.84474 14.2929 4.03227C14.1054 4.21981 14 4.47416 14 4.73938C14 5.0046 14.1054 5.25895 14.2929 5.44649C14.4804 5.63402 14.7348 5.73938 15 5.73938C15.7956 5.73938 16.5587 6.05545 17.1213 6.61806C17.6839 7.18067 18 7.94373 18 8.73938C17.9986 9.26462 17.8593 9.78028 17.5961 10.2348C17.3328 10.6893 16.9549 11.0668 16.5 11.3294C16.3517 11.4149 16.2279 11.537 16.1404 11.6841C16.0528 11.8312 16.0045 11.9983 16 12.1694C15.9958 12.3391 16.0349 12.5072 16.1137 12.6576C16.1924 12.8081 16.3081 12.936 16.45 13.0294L16.84 13.2894L16.97 13.3594C18.1754 13.9311 19.1923 14.8354 19.901 15.9657C20.6096 17.096 20.9805 18.4053 20.97 19.7394C20.97 20.0046 21.0754 20.259 21.2629 20.4465C21.4504 20.634 21.7048 20.7394 21.97 20.7394C22.2352 20.7394 22.4896 20.634 22.6771 20.4465C22.8646 20.259 22.97 20.0046 22.97 19.7394C22.9782 18.2048 22.5938 16.6936 21.8535 15.3494C21.1131 14.0052 20.0413 12.8727 18.74 12.0594Z"
          fill="white"
          className={`group-hover:fill -primary fill-white ${
            router === "/users" ? "fill -primary" : ""
          }`}
        />
      </svg>
    </div>
  );
};
export const Messagesicon = () => {
  const router = useLocation().pathname;
  return (
    <div>
      <svg
        width="25"
        height="25"
        className={`group-hover:fill -primary fill-white ${
          router === "#" ? "fill -primary" : ""
        }`}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8.61374 11.124C8.4176 11.124 8.22585 11.1821 8.06276 11.2911C7.89967 11.4001 7.77256 11.555 7.6975 11.7362C7.62244 11.9174 7.6028 12.1168 7.64106 12.3092C7.67933 12.5016 7.77378 12.6783 7.91248 12.817C8.05118 12.9557 8.22789 13.0501 8.42026 13.0884C8.61264 13.1267 8.81205 13.107 8.99326 13.032C9.17448 12.9569 9.32937 12.8298 9.43834 12.6667C9.54731 12.5036 9.60548 12.3119 9.60548 12.1157C9.60548 11.8527 9.50099 11.6004 9.315 11.4145C9.12902 11.2285 8.87677 11.124 8.61374 11.124ZM12.5807 11.124C12.3845 11.124 12.1928 11.1821 12.0297 11.2911C11.8666 11.4001 11.7395 11.555 11.6644 11.7362C11.5894 11.9174 11.5697 12.1168 11.608 12.3092C11.6463 12.5016 11.7407 12.6783 11.8794 12.817C12.0181 12.9557 12.1948 13.0501 12.3872 13.0884C12.5796 13.1267 12.779 13.107 12.9602 13.032C13.1414 12.9569 13.2963 12.8298 13.4053 12.6667C13.5143 12.5036 13.5724 12.3119 13.5724 12.1157C13.5724 11.8527 13.4679 11.6004 13.2819 11.4145C13.096 11.2285 12.8437 11.124 12.5807 11.124ZM16.5476 11.124C16.3515 11.124 16.1597 11.1821 15.9966 11.2911C15.8336 11.4001 15.7064 11.555 15.6314 11.7362C15.5563 11.9174 15.5367 12.1168 15.5749 12.3092C15.6132 12.5016 15.7077 12.6783 15.8464 12.817C15.9851 12.9557 16.1618 13.0501 16.3541 13.0884C16.5465 13.1267 16.7459 13.107 16.9271 13.032C17.1084 12.9569 17.2633 12.8298 17.3722 12.6667C17.4812 12.5036 17.5394 12.3119 17.5394 12.1157C17.5394 11.8527 17.4349 11.6004 17.2489 11.4145C17.0629 11.2285 16.8107 11.124 16.5476 11.124ZM12.5807 2.19836C11.2783 2.19836 9.98871 2.45488 8.78548 2.95328C7.58225 3.45167 6.48897 4.18218 5.56806 5.10309C3.70819 6.96296 2.66333 9.48547 2.66333 12.1157C2.65466 14.4058 3.44759 16.6267 4.90465 18.3934L2.92118 20.3769C2.78357 20.5163 2.69035 20.6934 2.65329 20.8858C2.61622 21.0782 2.63697 21.2773 2.71292 21.4579C2.79529 21.6363 2.92882 21.7863 3.09657 21.8887C3.26431 21.9911 3.4587 22.0413 3.65506 22.0331H12.5807C15.2109 22.0331 17.7334 20.9882 19.5933 19.1284C21.4532 17.2685 22.498 14.746 22.498 12.1157C22.498 9.48547 21.4532 6.96296 19.5933 5.10309C17.7334 3.24323 15.2109 2.19836 12.5807 2.19836ZM12.5807 20.0496H6.04515L6.96746 19.1273C7.06117 19.0354 7.13572 18.9259 7.18679 18.805C7.23786 18.6842 7.26444 18.5544 7.26498 18.4232C7.26126 18.1616 7.15432 17.912 6.96746 17.7289C5.66887 16.4318 4.8602 14.7245 4.67922 12.898C4.49825 11.0715 4.95616 9.2387 5.97496 7.71194C6.99375 6.18518 8.51039 5.05889 10.2665 4.52495C12.0226 3.99101 13.9095 4.08247 15.6057 4.78373C17.3019 5.485 18.7025 6.75269 19.5689 8.37082C20.4353 9.98895 20.7138 11.8574 20.357 13.6579C20.0002 15.4583 19.0302 17.0794 17.6123 18.2449C16.1943 19.4104 14.4162 20.0482 12.5807 20.0496Z" />
      </svg>
    </div>
  );
};
export const Walleticon = () => {
  const router = useLocation().pathname;
  return (
    <div>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        className={`group-hover:fill -primary fill-white ${
          router === "#" ? "fill -primary" : ""
        }`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.59405 14.6358H10.5693C10.8323 14.6358 11.0845 14.5313 11.2705 14.3453C11.4565 14.1593 11.561 13.9071 11.561 13.6441C11.561 13.381 11.4565 13.1288 11.2705 12.9428C11.0845 12.7568 10.8323 12.6523 10.5693 12.6523H7.59405C7.33103 12.6523 7.07878 12.7568 6.89279 12.9428C6.7068 13.1288 6.60232 13.381 6.60232 13.6441C6.60232 13.9071 6.7068 14.1593 6.89279 14.3453C7.07878 14.5313 7.33103 14.6358 7.59405 14.6358ZM19.4949 4.71844H5.61058C4.82151 4.71844 4.06475 5.0319 3.50679 5.58986C2.94883 6.14782 2.63538 6.90458 2.63538 7.69365V16.6193C2.63538 17.4083 2.94883 18.1651 3.50679 18.7231C4.06475 19.281 4.82151 19.5945 5.61058 19.5945H19.4949C20.284 19.5945 21.0407 19.281 21.5987 18.7231C22.1566 18.1651 22.4701 17.4083 22.4701 16.6193V7.69365C22.4701 6.90458 22.1566 6.14782 21.5987 5.58986C21.0407 5.0319 20.284 4.71844 19.4949 4.71844ZM20.4866 16.6193C20.4866 16.8823 20.3821 17.1345 20.1961 17.3205C20.0102 17.5065 19.7579 17.611 19.4949 17.611H5.61058C5.34756 17.611 5.09531 17.5065 4.90932 17.3205C4.72333 17.1345 4.61885 16.8823 4.61885 16.6193V10.6689H20.4866V16.6193ZM20.4866 8.68539H4.61885V7.69365C4.61885 7.43063 4.72333 7.17838 4.90932 6.99239C5.09531 6.8064 5.34756 6.70192 5.61058 6.70192H19.4949C19.7579 6.70192 20.0102 6.8064 20.1961 6.99239C20.3821 7.17838 20.4866 7.43063 20.4866 7.69365V8.68539Z" />
      </svg>
    </div>
  );
};
export const Activityicon = () => {
  const router = useLocation().pathname;
  return (
    <div>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        className={`group-hover:fill -primary fill-white ${
          router === "#" ? "fill -primary" : ""
        }`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19.4949 12.1896H12.5527V5.24748C12.5527 4.65244 12.156 4.25575 11.561 4.25575C6.60232 4.25575 2.63538 8.22269 2.63538 13.1814C2.63538 18.14 6.60232 22.107 11.561 22.107C16.5197 22.107 20.4866 18.14 20.4866 13.1814C20.4866 12.5863 20.0899 12.1896 19.4949 12.1896ZM12.5527 20.0243C8.78414 20.6194 5.21389 17.9417 4.71802 14.1731C4.12298 10.4045 6.80067 6.83426 10.5693 6.33839V13.1814C10.5693 13.7764 10.966 14.1731 11.561 14.1731H18.404C18.0073 17.2475 15.6271 19.6276 12.5527 20.0243ZM15.5279 2.27228C14.9329 2.27228 14.5362 2.66897 14.5362 3.26401V9.21443C14.5362 9.80947 14.9329 10.2062 15.5279 10.2062H21.4784C22.0734 10.2062 22.4701 9.80947 22.4701 9.21443C22.4701 5.34666 19.3957 2.27228 15.5279 2.27228ZM16.5197 8.22269V4.35492C18.5031 4.75162 19.9907 6.23922 20.3874 8.22269H16.5197Z" />
      </svg>
    </div>
  );
};
export const Analyticsicon = () => {
  const router = useLocation().pathname;
  return (
    <div>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        className={`group-hover:fill -primary fill-white ${
          router === "#" ? "fill -primary" : ""
        }`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.5527 6.77609C12.2897 6.77609 12.0375 6.88057 11.8515 7.06656C11.6655 7.25254 11.561 7.5048 11.561 7.76782V17.6852C11.561 17.9482 11.6655 18.2005 11.8515 18.3864C12.0375 18.5724 12.2897 18.6769 12.5527 18.6769C12.8158 18.6769 13.068 18.5724 13.254 18.3864C13.44 18.2005 13.5445 17.9482 13.5445 17.6852V7.76782C13.5445 7.5048 13.44 7.25254 13.254 7.06656C13.068 6.88057 12.8158 6.77609 12.5527 6.77609ZM7.59405 12.7265C7.33103 12.7265 7.07878 12.831 6.89279 13.017C6.7068 13.203 6.60232 13.4552 6.60232 13.7182V17.6852C6.60232 17.9482 6.7068 18.2005 6.89279 18.3864C7.07878 18.5724 7.33103 18.6769 7.59405 18.6769C7.85708 18.6769 8.10933 18.5724 8.29532 18.3864C8.4813 18.2005 8.58579 17.9482 8.58579 17.6852V13.7182C8.58579 13.4552 8.4813 13.203 8.29532 13.017C8.10933 12.831 7.85708 12.7265 7.59405 12.7265ZM17.5114 10.743C17.2484 10.743 16.9961 10.8475 16.8101 11.0335C16.6242 11.2195 16.5197 11.4717 16.5197 11.7348V17.6852C16.5197 17.9482 16.6242 18.2005 16.8101 18.3864C16.9961 18.5724 17.2484 18.6769 17.5114 18.6769C17.7744 18.6769 18.0267 18.5724 18.2127 18.3864C18.3987 18.2005 18.5031 17.9482 18.5031 17.6852V11.7348C18.5031 11.4717 18.3987 11.2195 18.2127 11.0335C18.0267 10.8475 17.7744 10.743 17.5114 10.743ZM19.4949 2.80914H5.61058C4.82151 2.80914 4.06475 3.1226 3.50679 3.68056C2.94883 4.23852 2.63538 4.99528 2.63538 5.78435V19.6686C2.63538 20.4577 2.94883 21.2145 3.50679 21.7724C4.06475 22.3304 4.82151 22.6439 5.61058 22.6439H19.4949C20.284 22.6439 21.0407 22.3304 21.5987 21.7724C22.1566 21.2145 22.4701 20.4577 22.4701 19.6686V5.78435C22.4701 4.99528 22.1566 4.23852 21.5987 3.68056C21.0407 3.1226 20.284 2.80914 19.4949 2.80914ZM20.4866 19.6686C20.4866 19.9317 20.3821 20.1839 20.1961 20.3699C20.0102 20.5559 19.7579 20.6604 19.4949 20.6604H5.61058C5.34756 20.6604 5.09531 20.5559 4.90932 20.3699C4.72333 20.1839 4.61885 19.9317 4.61885 19.6686V5.78435C4.61885 5.52133 4.72333 5.26907 4.90932 5.08309C5.09531 4.8971 5.34756 4.79261 5.61058 4.79261H19.4949C19.7579 4.79261 20.0102 4.8971 20.1961 5.08309C20.3821 5.26907 20.4866 5.52133 20.4866 5.78435V19.6686Z" />
      </svg>
    </div>
  );
};
export const Geticon = () => {
  const router = useLocation().pathname;
  return (
    <div>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        className={`group-hover:fill -primary fill-white ${
          router === "#" ? "fill -primary" : ""
        }`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.5536 7.6936C12.2906 7.6936 12.0383 7.79809 11.8523 7.98408C11.6663 8.17006 11.5619 8.42231 11.5619 8.68534V12.6523C11.5619 12.9153 11.6663 13.1676 11.8523 13.3535C12.0383 13.5395 12.2906 13.644 12.5536 13.644C12.8166 13.644 13.0689 13.5395 13.2549 13.3535C13.4408 13.1676 13.5453 12.9153 13.5453 12.6523V8.68534C13.5453 8.42231 13.4408 8.17006 13.2549 7.98408C13.0689 7.79809 12.8166 7.6936 12.5536 7.6936ZM13.466 16.2424C13.4443 16.1792 13.4143 16.1191 13.3767 16.0639L13.2577 15.9151C13.1183 15.7775 12.9412 15.6843 12.7488 15.6472C12.5564 15.6101 12.3573 15.6309 12.1767 15.7068C12.0565 15.757 11.9459 15.8275 11.8495 15.9151C11.7575 16.0078 11.6848 16.1177 11.6355 16.2385C11.5861 16.3593 11.5611 16.4887 11.5619 16.6192C11.5634 16.7488 11.5904 16.8769 11.6412 16.9961C11.6857 17.1192 11.7568 17.2309 11.8493 17.3235C11.9419 17.416 12.0537 17.4871 12.1767 17.5316C12.2954 17.5841 12.4238 17.6112 12.5536 17.6112C12.6834 17.6112 12.8117 17.5841 12.9305 17.5316C13.0535 17.4871 13.1653 17.416 13.2578 17.3235C13.3504 17.2309 13.4214 17.1192 13.466 16.9961C13.5168 16.8769 13.5438 16.7488 13.5453 16.6192C13.5502 16.5532 13.5502 16.4869 13.5453 16.4209C13.5283 16.3576 13.5015 16.2974 13.466 16.2424ZM12.5536 2.73492C10.5921 2.73492 8.6747 3.31657 7.0438 4.4063C5.4129 5.49603 4.14177 7.04491 3.39115 8.85707C2.64053 10.6692 2.44413 12.6633 2.82679 14.5871C3.20946 16.5108 4.15399 18.2779 5.54096 19.6649C6.92793 21.0519 8.69503 21.9964 10.6188 22.3791C12.5426 22.7617 14.5366 22.5653 16.3488 21.8147C18.161 21.0641 19.7098 19.793 20.7996 18.1621C21.8893 16.5312 22.4709 14.6137 22.4709 12.6523C22.4709 11.3499 22.2144 10.0603 21.716 8.85707C21.2176 7.65384 20.4871 6.56056 19.5662 5.63965C18.6453 4.71874 17.552 3.98823 16.3488 3.48984C15.1456 2.99144 13.856 2.73492 12.5536 2.73492ZM12.5536 20.5862C10.9844 20.5862 9.45048 20.1209 8.14576 19.2491C6.84104 18.3773 5.82413 17.1382 5.22364 15.6884C4.62314 14.2387 4.46602 12.6435 4.77215 11.1045C5.07828 9.56543 5.83391 8.15175 6.94349 7.04218C8.05306 5.9326 9.46674 5.17697 11.0058 4.87084C12.5448 4.56471 14.14 4.72183 15.5898 5.32233C17.0395 5.92282 18.2786 6.93973 19.1504 8.24445C20.0222 9.54917 20.4875 11.0831 20.4875 12.6523C20.4875 14.7565 19.6516 16.7745 18.1637 18.2624C16.6758 19.7503 14.6578 20.5862 12.5536 20.5862Z" />
      </svg>
    </div>
  );
};
export const Settingsicon = () => {
  const router = useLocation().pathname;
  return (
    <div>
      <svg
        width="25"
        height="25"
        className={`group-hover:fill -primary fill-white ${
          router === "#" ? "fill -primary" : ""
        }`}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21.7966 9.76181L19.9222 9.13701L20.8048 7.37172C20.8943 7.18695 20.9242 6.97896 20.8905 6.77646C20.8567 6.57395 20.761 6.38691 20.6164 6.24115L18.504 4.12875C18.3575 3.98206 18.1686 3.88499 17.964 3.85119C17.7595 3.81739 17.5494 3.84856 17.3635 3.94032L15.5982 4.82296L14.9734 2.94858C14.9074 2.7532 14.7822 2.58325 14.6151 2.46238C14.448 2.34151 14.2474 2.27574 14.0412 2.2742H11.066C10.8581 2.27367 10.6553 2.33849 10.4862 2.4595C10.3171 2.58052 10.1904 2.7516 10.1238 2.94858L9.49904 4.82296L7.73375 3.94032C7.54898 3.85085 7.34099 3.82092 7.13849 3.85467C6.93598 3.88842 6.74894 3.98418 6.60318 4.12875L4.49078 6.24115C4.34409 6.38769 4.24702 6.57653 4.21322 6.7811C4.17942 6.98568 4.21059 7.1957 4.30235 7.38164L5.18499 9.14693L3.31061 9.77173C3.11523 9.83771 2.94528 9.96296 2.82441 10.13C2.70354 10.2971 2.63777 10.4977 2.63623 10.704V13.6792C2.6357 13.8871 2.70052 14.0899 2.82153 14.259C2.94255 14.428 3.11363 14.5548 3.31061 14.6213L5.18499 15.2461L4.30235 17.0114C4.21288 17.1962 4.18295 17.4042 4.2167 17.6067C4.25045 17.8092 4.34621 17.9962 4.49078 18.142L6.60318 20.2544C6.74972 20.4011 6.93856 20.4981 7.14313 20.5319C7.34771 20.5657 7.55773 20.5346 7.74367 20.4428L9.50896 19.5602L10.1338 21.4345C10.2003 21.6315 10.327 21.8026 10.4961 21.9236C10.6652 22.0446 10.868 22.1095 11.0759 22.1089H14.0511C14.259 22.1095 14.4618 22.0446 14.6309 21.9236C14.8 21.8026 14.9267 21.6315 14.9933 21.4345L15.6181 19.5602L17.3833 20.4428C17.5669 20.53 17.7729 20.5587 17.9733 20.525C18.1738 20.4913 18.359 20.3968 18.504 20.2544L20.6164 18.142C20.7631 17.9954 20.8602 17.8066 20.894 17.602C20.9278 17.3974 20.8966 17.1874 20.8048 17.0015L19.9222 15.2362L21.7966 14.6114C21.9919 14.5454 22.1619 14.4202 22.2828 14.2531C22.4036 14.086 22.4694 13.8854 22.4709 13.6792V10.704C22.4715 10.496 22.4067 10.2932 22.2856 10.1242C22.1646 9.95509 21.9935 9.82834 21.7966 9.76181ZM20.4875 12.9651L19.2974 13.3618C19.0237 13.4506 18.7727 13.5978 18.5616 13.7933C18.3505 13.9888 18.1845 14.2279 18.075 14.494C17.9656 14.76 17.9153 15.0467 17.9278 15.3341C17.9402 15.6216 18.015 15.9029 18.147 16.1585L18.7123 17.2891L17.6214 18.38L16.5205 17.7849C16.2662 17.6582 15.9876 17.5877 15.7037 17.578C15.4197 17.5683 15.1369 17.6197 14.8746 17.7288C14.6122 17.8379 14.3763 18.0021 14.1829 18.2102C13.9895 18.4184 13.8431 18.6657 13.7536 18.9354L13.3569 20.1254H11.78L11.3833 18.9354C11.2946 18.6617 11.1473 18.4106 10.9518 18.1996C10.7563 17.9885 10.5173 17.8225 10.2512 17.713C9.98513 17.6036 9.69843 17.5533 9.411 17.5657C9.12357 17.5782 8.84228 17.653 8.58665 17.7849L7.45607 18.3502L6.36516 17.2593L6.9602 16.1585C7.0922 15.9029 7.167 15.6216 7.17942 15.3341C7.19184 15.0467 7.14159 14.76 7.03214 14.494C6.92269 14.2279 6.75668 13.9888 6.5456 13.7933C6.33453 13.5978 6.08345 13.4506 5.80979 13.3618L4.61971 12.9651V11.418L5.80979 11.0213C6.08345 10.9325 6.33453 10.7853 6.5456 10.5898C6.75668 10.3943 6.92269 10.1552 7.03214 9.88917C7.14159 9.6231 7.19184 9.3364 7.17942 9.04897C7.167 8.76154 7.0922 8.48025 6.9602 8.22462L6.39491 7.12379L7.48582 6.03288L8.58665 6.59817C8.84228 6.73017 9.12357 6.80497 9.411 6.81739C9.69843 6.82981 9.98513 6.77956 10.2512 6.67011C10.5173 6.56066 10.7563 6.39465 10.9518 6.18357C11.1473 5.9725 11.2946 5.72142 11.3833 5.44776L11.78 4.25768H13.3271L13.7238 5.44776C13.8126 5.72142 13.9598 5.9725 14.1553 6.18357C14.3508 6.39465 14.5899 6.56066 14.856 6.67011C15.1221 6.77956 15.4087 6.82981 15.6962 6.81739C15.9836 6.80497 16.2649 6.73017 16.5205 6.59817L17.6511 6.03288L18.742 7.12379L18.147 8.22462C18.0203 8.47894 17.9497 8.75752 17.94 9.0415C17.9303 9.32547 17.9818 9.60822 18.0908 9.87058C18.1999 10.133 18.3641 10.3688 18.5723 10.5622C18.7804 10.7556 19.0277 10.902 19.2974 10.9916L20.4875 11.3883V12.9651ZM12.5536 8.22462C11.769 8.22462 11.002 8.45727 10.3497 8.89317C9.69732 9.32906 9.18886 9.94861 8.88861 10.6735C8.58836 11.3983 8.50981 12.196 8.66287 12.9655C8.81594 13.735 9.19375 14.4418 9.74854 14.9966C10.3033 15.5514 11.0102 15.9292 11.7797 16.0823C12.5492 16.2353 13.3468 16.1568 14.0717 15.8565C14.7965 15.5563 15.4161 15.0478 15.852 14.3955C16.2879 13.7431 16.5205 12.9761 16.5205 12.1916C16.5205 11.1395 16.1026 10.1305 15.3586 9.38651C14.6147 8.64256 13.6057 8.22462 12.5536 8.22462ZM12.5536 14.175C12.1613 14.175 11.7778 14.0587 11.4516 13.8408C11.1255 13.6228 10.8712 13.313 10.7211 12.9506C10.571 12.5882 10.5317 12.1894 10.6082 11.8046C10.6848 11.4198 10.8737 11.0664 11.1511 10.789C11.4285 10.5116 11.7819 10.3227 12.1666 10.2462C12.5514 10.1697 12.9502 10.2089 13.3126 10.3591C13.6751 10.5092 13.9848 10.7634 14.2028 11.0896C14.4207 11.4158 14.5371 11.7993 14.5371 12.1916C14.5371 12.7176 14.3281 13.2221 13.9561 13.5941C13.5841 13.9661 13.0796 14.175 12.5536 14.175Z" />
      </svg>
    </div>
  );
};
export const Searchicon = () => {
  return (
    <div>
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0285 15.7496C12.7585 16.7368 11.1626 17.3247 9.42944 17.3247C5.28731 17.3247 1.92944 13.9668 1.92944 9.82471C1.92944 5.68257 5.28731 2.32471 9.42944 2.32471C13.5716 2.32471 16.9294 5.68257 16.9294 9.82471C16.9294 11.5579 16.3416 13.1537 15.3543 14.4237L20.4049 19.4743C20.771 19.8404 20.771 20.434 20.4049 20.8001C20.0387 21.1662 19.4451 21.1662 19.079 20.8001L14.0285 15.7496ZM15.0544 9.82471C15.0544 12.9313 12.536 15.4497 9.42944 15.4497C6.32284 15.4497 3.80444 12.9313 3.80444 9.82471C3.80444 6.7181 6.32284 4.19971 9.42944 4.19971C12.536 4.19971 15.0544 6.7181 15.0544 9.82471Z"
          fill="#C1C1C1"
        />
      </svg>
    </div>
  );
};
export const Notficationicon = () => {
  return (
    <div>
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.74 17.3466C19.74 17.8042 19.3691 18.1751 18.9115 18.1751H3.69348C3.23592 18.1751 2.86499 17.8042 2.86499 17.3466C2.86499 16.8891 3.23592 16.5181 3.69348 16.5181H3.70874V10.7444C3.70874 6.61191 7.10905 3.26233 11.3025 3.26233C15.4959 3.26233 18.8962 6.61191 18.8962 10.7444V16.5181H18.9115C19.3691 16.5181 19.74 16.8891 19.74 17.3466ZM5.39624 16.5181H17.2087V10.7444C17.2087 7.52739 14.5644 4.91931 11.3025 4.91931C8.04055 4.91931 5.39624 7.52739 5.39624 10.7444V16.5181ZM9.40503 19.9084C9.1755 19.4443 9.61285 19.0036 10.1306 19.0036H12.4744C12.9921 19.0036 13.4295 19.4443 13.1999 19.9084C13.0983 20.114 12.9617 20.3035 12.794 20.4682C12.3985 20.8566 11.8619 21.0748 11.3025 21.0748C10.743 21.0748 10.2065 20.8566 9.81094 20.4682C9.64324 20.3035 9.5067 20.114 9.40503 19.9084Z"
          fill="#C1C1C1"
        />
        <circle cx="16.4587" cy="6.54333" r="4.21875" fill="white" />
        <circle cx="16.459" cy="6.54358" r="3.28125" fill="#FF4CFF" />
      </svg>
    </div>
  );
};
export const Crossicon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <g clipPath="url(#clip0_2111_140)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 17.6525L21.6287 24.2813C21.9805 24.633 22.4576 24.8306 22.955 24.8306C23.4524 24.8306 23.9295 24.633 24.2812 24.2813C24.633 23.9295 24.8306 23.4525 24.8306 22.955C24.8306 22.4576 24.633 21.9805 24.2812 21.6288L17.65 15L24.28 8.37127C24.4541 8.1971 24.5922 7.99035 24.6863 7.76282C24.7805 7.5353 24.829 7.29145 24.8289 7.0452C24.8288 6.79895 24.7803 6.55512 24.686 6.32764C24.5917 6.10016 24.4535 5.89347 24.2794 5.71939C24.1052 5.54531 23.8985 5.40723 23.6709 5.31305C23.4434 5.21887 23.1996 5.17042 22.9533 5.17048C22.7071 5.17054 22.4632 5.2191 22.2357 5.31339C22.0083 5.40768 21.8016 5.54585 21.6275 5.72002L15 12.3488L8.37124 5.72002C8.19836 5.54085 7.99154 5.39792 7.76283 5.29954C7.53411 5.20117 7.2881 5.14933 7.03914 5.14705C6.79018 5.14477 6.54326 5.1921 6.31279 5.28626C6.08232 5.38043 5.8729 5.51956 5.69677 5.69552C5.52064 5.87149 5.38132 6.08077 5.28693 6.31115C5.19255 6.54154 5.14499 6.78841 5.14704 7.03738C5.14908 7.28634 5.20069 7.5324 5.29885 7.7612C5.397 7.99 5.53975 8.19697 5.71874 8.37002L12.35 15L5.71999 21.63C5.541 21.8031 5.39825 22.01 5.3001 22.2388C5.20194 22.4676 5.15033 22.7137 5.14829 22.9627C5.14624 23.2116 5.1938 23.4585 5.28818 23.6889C5.38257 23.9193 5.52189 24.1285 5.69802 24.3045C5.87415 24.4805 6.08357 24.6196 6.31404 24.7138C6.54451 24.8079 6.79143 24.8553 7.04039 24.853C7.28935 24.8507 7.53536 24.7989 7.76407 24.7005C7.99279 24.6021 8.19961 24.4592 8.37249 24.28L15 17.6525Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_2111_140">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Menuicon = () => {
  return (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="4" fill="#FF4CFF" />
        <path
          d="M29 18H11M29 14H11M29 22H11M29 26H11"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
export const Electricicon = () => {
  return (
    <div>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="13.0829"
          cy="13.1839"
          r="12.7812"
          fill="#FEC28E"
          fillOpacity="0.6"
        />
        <path
          d="M13.0826 9.09332L11.0376 12.1608H12.4009V14.2058L14.4459 11.1383H13.0826V9.09332Z"
          fill="#040707"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.4829 11.5729C17.3795 12.4507 17.0267 13.2804 16.4662 13.9638C16.1384 14.3643 15.305 15.5085 15.1278 16.2515H10.3562C10.1789 15.5078 9.34458 14.3636 9.0167 13.9628C8.45653 13.279 8.10405 12.4491 8.00102 11.5712C7.89944 10.6952 8.05232 9.80843 8.44137 9.017C8.83409 8.21953 9.44453 7.54952 10.2021 7.08448C10.9663 6.6149 11.8458 6.36664 12.7427 6.36737C13.6418 6.36737 14.5225 6.61618 15.2832 7.0855C16.0406 7.55072 16.6508 8.22084 17.0433 9.01836C17.4322 9.80996 17.5848 10.6968 17.4829 11.5729ZM14.6448 15.5698H10.8388C10.6936 15.2348 10.4997 14.8991 10.319 14.6138C10.0813 14.2389 9.82279 13.8776 9.54464 13.5316C9.06687 12.9487 8.7662 12.241 8.67825 11.4925C8.59167 10.7464 8.72183 9.99126 9.05317 9.31727C9.38926 8.63531 9.91156 8.06243 10.5596 7.66492C11.2163 7.26153 11.972 7.04832 12.7427 7.04903C13.5164 7.04903 14.273 7.26342 14.9257 7.66594C15.5735 8.06354 16.0956 8.63641 16.4315 9.31829C16.7627 9.99245 16.8926 10.7477 16.8057 11.4938C16.7174 12.2422 16.4165 12.9497 15.9386 13.5323C15.6604 13.8781 15.4019 14.2394 15.1646 14.6145C14.984 14.8997 14.7904 15.2348 14.6452 15.5698H14.6448Z"
          fill="#040707"
        />
        <path
          d="M10.3561 17.2742C10.3561 17.1838 10.392 17.0972 10.4559 17.0332C10.5198 16.9693 10.6065 16.9334 10.6969 16.9334H14.7869C14.8773 16.9334 14.964 16.9693 15.0279 17.0332C15.0918 17.0972 15.1277 17.1838 15.1277 17.2742C15.1277 17.3646 15.0918 17.4513 15.0279 17.5152C14.964 17.5792 14.8773 17.6151 14.7869 17.6151H10.6969C10.6065 17.6151 10.5198 17.5792 10.4559 17.5152C10.392 17.4513 10.3561 17.3646 10.3561 17.2742Z"
          fill="#040707"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3562 18.2965H15.1278V19.319C15.1278 19.4998 15.056 19.6732 14.9282 19.801C14.8003 19.9288 14.627 20.0007 14.4462 20.0007H11.0379C10.8571 20.0007 10.6837 19.9288 10.5559 19.801C10.428 19.6732 10.3562 19.4998 10.3562 19.319V18.2965ZM11.0379 18.9782H14.4462V19.319H11.0379V18.9782Z"
          fill="#040707"
        />
      </svg>
    </div>
  );
};

export const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clipPath="url(#clip0_2031_4087)">
        <path
          d="M2.625 18H13.875C14.5723 17.998 15.2403 17.7195 15.7324 17.2255C16.2245 16.7316 16.5006 16.0625 16.5 15.3652V9.7125C16.5 9.51359 16.421 9.32282 16.2803 9.18217C16.1397 9.04152 15.9489 8.9625 15.75 8.9625C15.5511 8.9625 15.3603 9.04152 15.2197 9.18217C15.079 9.32282 15 9.51359 15 9.7125V15.3652C15.001 15.6648 14.8831 15.9526 14.6722 16.1653C14.4613 16.378 14.1746 16.4984 13.875 16.5H2.625C2.32543 16.4984 2.03873 16.378 1.82781 16.1653C1.6169 15.9526 1.499 15.6648 1.5 15.3652V4.13475C1.499 3.83518 1.6169 3.54745 1.82781 3.3347C2.03873 3.12196 2.32543 3.00159 2.625 3H8.25C8.44891 3 8.63968 2.92098 8.78033 2.78033C8.92098 2.63968 9 2.44891 9 2.25C9 2.05109 8.92098 1.86032 8.78033 1.71967C8.63968 1.57902 8.44891 1.5 8.25 1.5H2.625C1.92773 1.50199 1.25973 1.78052 0.767594 2.27448C0.275461 2.76845 -0.000597818 3.43748 9.72081e-07 4.13475V15.3652C-0.000597818 16.0625 0.275461 16.7316 0.767594 17.2255C1.25973 17.7195 1.92773 17.998 2.625 18Z"
          fill="#12B757"
        />
        <path
          d="M7.09124 7.90795L6.49949 10.6184C6.4727 10.7414 6.47728 10.8691 6.5128 10.9898C6.54832 11.1105 6.61364 11.2204 6.70274 11.3092C6.79307 11.3958 6.90294 11.4594 7.02306 11.4945C7.14317 11.5296 7.26998 11.5353 7.39274 11.5109L10.0972 10.9177C10.2377 10.8869 10.3663 10.8163 10.4677 10.7144L17.3032 3.87895C17.5122 3.67001 17.678 3.42196 17.7911 3.14895C17.9042 2.87594 17.9624 2.58333 17.9624 2.28782C17.9624 1.99232 17.9042 1.69971 17.7911 1.4267C17.678 1.15369 17.5122 0.905636 17.3032 0.6967C16.8748 0.287302 16.3051 0.0588379 15.7125 0.0588379C15.1199 0.0588379 14.5502 0.287302 14.1217 0.6967L7.29674 7.53895C7.1943 7.63972 7.12298 7.7678 7.09124 7.90795ZM15.1822 1.75795C15.3249 1.62126 15.5149 1.54495 15.7125 1.54495C15.9101 1.54495 16.1001 1.62126 16.2427 1.75795C16.3815 1.89942 16.4592 2.08967 16.4592 2.28782C16.4592 2.48598 16.3815 2.67623 16.2427 2.8177L15.7125 3.34795L14.652 2.28745L15.1822 1.75795ZM8.50724 8.44345L13.5877 3.3502L14.6377 4.40545L9.55499 9.5002L8.20874 9.7957L8.50724 8.44345Z"
          fill="#12B757"
        />
      </g>
      <defs>
        <clipPath id="clip0_2031_4087">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.15 9.14471L17.85 18.225C17.8245 19.0026 17.4969 19.7397 16.9368 20.2798C16.3766 20.8199 15.6281 21.1205 14.85 21.1177H9.15002C8.37244 21.1205 7.62434 20.8204 7.0643 20.2809C6.50427 19.7415 6.17634 19.0051 6.15002 18.228L5.85002 9.14471C5.84346 8.9458 5.91618 8.75243 6.05219 8.60713C6.1882 8.46184 6.37636 8.37653 6.57527 8.36996C6.77418 8.3634 6.96756 8.43612 7.11285 8.57213C7.25814 8.70814 7.34346 8.8963 7.35002 9.09521L7.65002 18.1777C7.66496 18.5654 7.82956 18.9323 8.10927 19.2012C8.38897 19.4702 8.762 19.6203 9.15002 19.62H14.85C15.2385 19.6202 15.612 19.4697 15.8918 19.2002C16.1716 18.9306 16.3358 18.563 16.35 18.1747L16.65 9.09521C16.6566 8.8963 16.7419 8.70814 16.8872 8.57213C17.0325 8.43612 17.2259 8.3634 17.4248 8.36996C17.6237 8.37653 17.8118 8.46184 17.9479 8.60713C18.0839 8.75243 18.1566 8.9458 18.15 9.14471ZM19.1423 6.12296C19.1423 6.32187 19.0633 6.51264 18.9226 6.65329C18.7819 6.79395 18.5912 6.87296 18.3923 6.87296H5.60852C5.40961 6.87296 5.21884 6.79395 5.07819 6.65329C4.93754 6.51264 4.85852 6.32187 4.85852 6.12296C4.85852 5.92405 4.93754 5.73328 5.07819 5.59263C5.21884 5.45198 5.40961 5.37296 5.60852 5.37296H7.93352C8.17116 5.3736 8.40053 5.28581 8.57701 5.12666C8.75348 4.96751 8.86443 4.7484 8.88827 4.51196C8.94362 3.95733 9.20347 3.44316 9.61719 3.06964C10.0309 2.69613 10.5689 2.49001 11.1263 2.49146H12.8738C13.4312 2.49001 13.9691 2.69613 14.3828 3.06964C14.7966 3.44316 15.0564 3.95733 15.1118 4.51196C15.1356 4.7484 15.2466 4.96751 15.423 5.12666C15.5995 5.28581 15.8289 5.3736 16.0665 5.37296H18.3915C18.5904 5.37296 18.7812 5.45198 18.9219 5.59263C19.0625 5.73328 19.1415 5.92405 19.1415 6.12296H19.1423ZM10.1903 5.37296H13.8113C13.7127 5.14777 13.6483 4.90915 13.62 4.66496C13.6014 4.48009 13.5149 4.3087 13.3772 4.184C13.2394 4.05929 13.0603 3.99015 12.8745 3.98996H11.127C10.9412 3.99015 10.7621 4.05929 10.6244 4.184C10.4866 4.3087 10.4001 4.48009 10.3815 4.66496C10.353 4.90919 10.2891 5.14781 10.1903 5.37296ZM10.9455 16.7362V10.35C10.9455 10.1511 10.8665 9.96029 10.7259 9.81963C10.5852 9.67898 10.3944 9.59996 10.1955 9.59996C9.99661 9.59996 9.80584 9.67898 9.66519 9.81963C9.52454 9.96029 9.44552 10.1511 9.44552 10.35V16.7392C9.44552 16.9381 9.52454 17.1289 9.66519 17.2695C9.80584 17.4102 9.99661 17.4892 10.1955 17.4892C10.3944 17.4892 10.5852 17.4102 10.7259 17.2695C10.8665 17.1289 10.9455 16.9381 10.9455 16.7392V16.7362ZM14.556 16.7362V10.35C14.556 10.1511 14.477 9.96029 14.3363 9.81963C14.1957 9.67898 14.0049 9.59996 13.806 9.59996C13.6071 9.59996 13.4163 9.67898 13.2757 9.81963C13.135 9.96029 13.056 10.1511 13.056 10.35V16.7392C13.056 16.9381 13.135 17.1289 13.2757 17.2695C13.4163 17.4102 13.6071 17.4892 13.806 17.4892C14.0049 17.4892 14.1957 17.4102 14.3363 17.2695C14.477 17.1289 14.556 16.9381 14.556 16.7392V16.7362Z"
        fill="#F6220E"
      />
    </svg>
  );
};
export const CallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.99552 4.69741C3.99752 4.69741 3.94752 4.74941 3.88452 4.81141C3.64252 5.04641 3.14152 5.53541 3.13647 6.55841C3.12852 7.98941 4.06952 10.6464 8.60052 15.1764C13.1105 19.6844 15.7635 20.6364 17.1975 20.6364H17.2185C18.2415 20.6314 18.7295 20.1294 18.9655 19.8884C19.0375 19.8144 19.0955 19.7604 19.1365 19.7264C20.1325 18.7244 20.6425 17.9784 20.6376 17.5004C20.6305 17.0124 20.0235 16.4354 19.1845 15.6374C18.9175 15.3834 18.6275 15.1074 18.3215 14.8014C17.5285 14.0104 17.1355 14.1454 16.2715 14.4494C15.0765 14.8684 13.4365 15.4384 10.8885 12.8894C8.33652 10.3394 8.90752 8.70141 9.32552 7.50641C9.62752 6.64241 9.76552 6.24841 8.97152 5.45441C8.66052 5.14441 8.38152 4.85041 8.12452 4.58041C7.33152 3.74641 6.75952 3.14341 6.27452 3.13641H6.26652C5.78752 3.13641 5.04352 3.64841 3.99052 4.70141C3.99352 4.69841 3.99552 4.69741 3.99552 4.69741ZM17.1985 22.1364C14.7065 22.1364 11.4575 20.1524 7.54052 16.2374C3.60852 12.3064 1.62152 9.04741 1.63644 6.55041C1.64552 4.90041 2.51052 4.05541 2.83552 3.73841C2.85252 3.71741 2.91052 3.66041 2.93052 3.64041C4.36452 2.20541 5.33152 1.62541 6.29352 1.63626C7.41052 1.65141 8.20552 2.48741 9.21152 3.54641C9.46052 3.80841 9.73052 4.09341 10.0315 4.39341C11.4915 5.85341 11.0755 7.04441 10.7415 8.00041C10.3775 9.04341 10.0625 9.94341 11.9485 11.8294C13.8365 13.7154 14.7365 13.4004 15.7755 13.0334C16.7325 12.6994 17.9205 12.2814 19.3825 13.7414C19.6785 14.0374 19.9595 14.3044 20.2185 14.5514C21.2825 15.5624 22.1225 16.3614 22.1367 17.4814C22.1485 18.4364 21.5685 19.4094 20.1365 20.8424L19.5025 20.4124L20.0385 20.9364C19.7215 21.2614 18.8775 22.1274 17.2265 22.1364H17.1985Z"
        fill="#FF4CFF"
      />
    </svg>
  );
};
export const MailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6589 2C19.9889 2 22.4999 4.717 22.4999 8.32V15.188C22.4999 17.032 21.8479 18.698 20.6629 19.88C19.5999 20.939 18.2209 21.5 16.6749 21.5H6.82188C5.27888 21.5 3.90088 20.94 2.83688 19.88C1.65188 18.698 0.999878 17.032 0.999878 15.188V8.32C0.999878 4.717 3.51088 2 6.84088 2H16.6589ZM16.6589 3.5H6.84088C4.32588 3.5 2.49988 5.527 2.49988 8.32V15.188C2.49988 16.631 2.99588 17.92 3.89588 18.817C4.67188 19.592 5.68488 20 6.82488 20H16.6589C16.6609 19.998 16.6689 20 16.6749 20C17.8159 20 18.8279 19.592 19.6039 18.817C20.5049 17.92 20.9999 16.631 20.9999 15.188V8.32C20.9999 5.527 19.1739 3.5 16.6589 3.5ZM18.2349 8.1288C18.4959 8.4498 18.4469 8.9218 18.1259 9.1838L13.6819 12.7958C13.1199 13.2418 12.4479 13.4648 11.7769 13.4648C11.1079 13.4648 10.4409 13.2438 9.88288 12.8018L5.39788 9.1858C5.07488 8.9258 5.02488 8.4528 5.28388 8.1308C5.54488 7.8098 6.01688 7.7588 6.33888 8.0178L10.8199 11.6298C11.3829 12.0758 12.1759 12.0758 12.7429 11.6258L17.1789 8.0198C17.5009 7.7568 17.9729 7.8068 18.2349 8.1288Z"
        fill="#FF4CFF"
      />
    </svg>
  );
};
export const AdministratorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
    >
      <path
        d="M13.1609 1L7.23679 7.2359L1.00089 0.999999"
        stroke="#A5B4CB"
        strokeWidth="1.96339"
      />
    </svg>
  );
};
export const PlusIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="43"
        height="43"
        viewBox="0 0 43 43"
        fill="none"
      >
        <circle cx="21.4381" cy="21.9096" r="20.9428" fill="#FEE8FE" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.2194 22.8783H22.407V28.6908H20.4695V22.8783H14.657V20.9408H20.4695V15.1283H22.407V20.9408H28.2194V22.8783Z"
          fill="#FF4CFF"
        />
      </svg>
    </>
  );
};
export const DropdownIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="7"
        viewBox="0 0 9 7"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.62451 1.08184C8.25114 0.708468 7.64578 0.708468 7.27241 1.08184C5.79768 2.55657 3.40667 2.55657 1.93194 1.08184C1.55857 0.708468 0.953215 0.708468 0.579842 1.08184C0.206469 1.45521 0.206469 2.06057 0.579842 2.43394L3.92613 5.78023C4.2995 6.1536 4.90486 6.1536 5.27823 5.78023L8.62451 2.43394C8.99788 2.06057 8.99788 1.45521 8.62451 1.08184Z"
          fill="#777E91"
        />
      </svg>
    </>
  );
};
export const DebitIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="17"
        viewBox="0 0 27 17"
        fill="none"
      >
        <path
          d="M10.2224 5.98993C10.2224 4.01982 11.8195 2.42273 13.7896 2.42273C15.7597 2.42273 17.3568 4.01982 17.3568 5.98993V11.6748C17.3568 13.6449 15.7597 15.242 13.7896 15.242C11.8195 15.242 10.2224 13.6449 10.2224 11.6748V5.98993Z"
          fill="#FF5F00"
        />
        <path
          d="M10.6759 8.83267C10.6759 8.1682 10.7555 7.52289 10.9053 6.9054C11.5579 4.21541 11.5188 0.679077 8.75076 0.679077C4.24364 0.679077 0.597168 4.32555 0.597168 8.83267C0.597168 13.3398 4.24364 16.9863 8.75076 16.9863C11.5107 16.9863 11.5538 13.4453 10.9052 10.7626C10.7555 10.1435 10.6759 9.49691 10.6759 8.83267Z"
          fill="#EB001B"
        />
        <path
          d="M26.9844 8.83267C26.9844 13.3398 23.3379 16.9863 18.8308 16.9863C16.0691 16.9863 16.0333 13.4499 16.6784 10.7646C16.8271 10.1457 16.9056 9.49881 16.9056 8.83267C16.9056 8.1682 16.826 7.5229 16.6762 6.9054C16.0237 4.21541 16.0628 0.679077 18.8308 0.679077C23.3379 0.679077 26.9844 4.3482 26.9844 8.83267Z"
          fill="#F79E1B"
        />
      </svg>
    </div>
  );
};
export const Debit2Icon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="27"
        viewBox="0 0 40 27"
        fill="none"
      >
        <circle cx="14.0787" cy="13.3914" r="13.0892" fill="#FE626F" />
        <circle cx="26.1288" cy="13.3914" r="13.0892" fill="#FEEDB7" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0825 21.7806C18.1709 24.279 22.0385 24.279 24.1269 21.7806C26.0259 19.5089 27.1689 16.5833 27.1689 13.3909C27.1689 10.1984 26.0259 7.27283 24.1269 5.00109C22.0385 2.50273 18.1709 2.50273 16.0825 5.00109C14.1835 7.27283 13.0405 10.1984 13.0405 13.3909C13.0405 16.5833 14.1835 19.5089 16.0825 21.7806Z"
          fill="#FFAA85"
        />
      </svg>
    </div>
  );
};
export const Flag2Icon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
      >
        <circle cx="18.9237" cy="19.1998" r="18.3249" fill="white" />
        <circle cx="18.9232" cy="19.2004" r="13.0892" fill="#F0F0F0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3577 19.2004C14.3577 13.2259 7.92465 9.82601 6.26917 15.5666C5.93645 16.7203 5.75818 17.9396 5.75818 19.2004C5.75818 20.4613 5.93645 21.6805 6.26917 22.8342C7.92465 28.5748 14.3577 25.1749 14.3577 19.2004Z"
          fill="#0F56CA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.4918 19.1991C23.4918 25.1733 29.9245 28.5727 31.5796 22.8323C31.9122 21.6787 32.0905 20.4597 32.0905 19.1991C32.0905 17.9384 31.9122 16.7194 31.5796 15.5658C29.9245 9.82549 23.4918 13.2249 23.4918 19.1991Z"
          fill="#F1375E"
        />
      </svg>
    </>
  );
};
export const EmailIcon = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.5 5H5.5C4.39543 5 3.5 5.89543 3.5 7V17C3.5 18.1046 4.39543 19 5.5 19H19.5C20.6046 19 21.5 18.1046 21.5 17V7C21.5 5.89543 20.6046 5 19.5 5Z"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 7L12.5 13L21.5 7"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
